import React from 'react';
import Reveal from './Reveal';

const Policies: React.FC = () => {
  

  return (
    <section id="policies" className="section">
      <div className="container">
        <Reveal>
        <Reveal className="text-center mb-12" delay={0.05}>
          <h2 className="section-title">
            私が目指すこと
          </h2>
        </Reveal>

        <div className="max-w-4xl mx-auto">
          <Reveal delay={0.12}>
            <div className="card">
              <h3
                className="text-xl font-bold mb-4 text-gray-800 border-b border-pink-200 pb-2"
                style={{ borderBottomColor: '#e3628d' }}
              >
                私だからできる４つのもっと
              </h3>

              <div className="text-gray-700 leading-relaxed">
                <div>
                  <h3 className="text-lg md:text-xl font-bold mb-2" style={{ color: '#e3628d' }}>言葉の力でもっと「見える化」。見えると町田が好きになる</h3>
                  <p>
                    27年間、編集とライターを続けてきた私の強みは「わかりやすい言葉」で表現できることです。町田の魅力や課題をわかりやすい言葉で「見える化」することで、「知らないうちに開発が決まっていた」「何のためかわからない」といった市民のモヤモヤが解消され、市民はもっと町田を好きになります。多くの市民で町田の今を共有し、「もっと身近な町田」を作ります。
                  </p>
                </div>

                <div className="border-t border-gray-200 mt-6 pt-6">
                  <h3 className="text-lg md:text-xl font-bold mb-2" style={{ color: '#e3628d' }}>町田の女性を もっと元気に</h3>
                  <p>
                    私の20代は生理痛がひどく、今は更年期で体と心が揺らいでいます。昨年は乳がんに罹患し、切除手術と放射線治療を経験。そんな経験を踏まえ、つくづく感じるのは女性の健康と元気の大切さ。女性の元気は、家庭、子ども、地域、経済を安定させる力になります。自らの経験を踏まえ、「女性の心と体の悩みに寄り添う町田」にします。
                  </p>
                </div>

                <div className="border-t border-gray-200 mt-6 pt-6">
                  <h3 className="text-lg md:text-xl font-bold mb-2" style={{ color: '#e3628d' }}>生物多様性こそ町田の宝。「トカイナカ町田」をもっとアピール</h3>
                  <p>
                    私は2021年から「芹ヶ谷公園をより良くする市民の会」の共同代表をつとめており、町田の自然が失われつつあることを危惧しています。取材した専門家は口を揃えて「町田の生物多様性は突出してすばらしい」と言います。町田最大の魅力は都会と田舎のバランスのよさ。自然と開発が共存できる環境を作り、緑を守り、「トカイナカ町田」をもっとアピールします。
                  </p>
                </div>

                <div className="border-t border-gray-200 mt-6 pt-6">
                  <h3 className="text-lg md:text-xl font-bold mb-2" style={{ color: '#e3628d' }}>「巻き込み力」で 地域をもっと盛り上げる</h3>
                  <p>
                    地元の魅力をまちの人に伝えたい！と私が2015年に創刊したのが「玉川つばめ通信」です。この通信のほかにも、玉川音頭やスナックつばめ、ゆるつばめ会議など、多くのイベントを玉川学園で開催してきました。少子高齢化の日本にあって地域を活性化できるのは、ズバリ「巻き込み力」。私の得意技、「巻き込み力」で町田をもっと盛り上げます。
                  </p>
                </div>
              </div>
            </div>
          </Reveal>
        </div>
        </Reveal>
      </div>
    </section>
  );
};

export default Policies; 